import React from "react";

import { FormattedMessage } from "react-intl";

import noData from "@app/assets/reports/statelessness-chart.svg";

import styles from "./NoChart.module.scss";

interface Props {
  chartTitle?: string;
}

const NoChart: React.FC<Props> = ({ chartTitle }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {chartTitle && <h2 className={styles.chartTitle}>{chartTitle}</h2>}
        <img alt="No Data" src={noData} />
        <h1 className={styles.title}>
          <FormattedMessage
            id="reports.overview.chart.noData.title"
            defaultMessage="Nothing to see here"
            description="No data stub's title on a Overview tab in Reports"
          />
        </h1>
        <h3 className={styles.subtitle}>
          <FormattedMessage
            id="reports.overview.chart.noData.subtitle"
            defaultMessage="Add some data to populate this chart"
            description="No data stub's subtitle on a Overview tab in Reports"
          />
        </h3>
      </div>
    </div>
  );
};

export default NoChart;
